/**
 * Authority Dashboard
 * Main dashboard container for Authority users
 * Handles layout and loads global settings data used across all views
 */

import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardLayout } from '../views/shared';
import { useSidebar } from '../hooks/useRedux';
import { fetchAuthorityDropdowns, selectDropdownsLoaded, selectSettingsLoading } from '../store/slices/settingsSlice';

const AuthorityDashboard = () => {
  const dispatch = useDispatch();
  const { isOpen: sidebarOpen, toggle: handleSidebarToggle } = useSidebar();
  const dropdownsLoaded = useSelector(selectDropdownsLoaded);
  const isLoading = useSelector(selectSettingsLoading);
  const hasFetched = useRef(false);
  
  // Load authority dropdowns on initial mount (used across all views)
  // Always fetch on mount to ensure data is loaded, but prevent duplicate calls
  useEffect(() => {
    console.log('[AuthorityDashboard] Component mounted');
    console.log('[AuthorityDashboard] dropdownsLoaded:', dropdownsLoaded);
    console.log('[AuthorityDashboard] isLoading:', isLoading);
    console.log('[AuthorityDashboard] hasFetched (ref):', hasFetched.current);
    
    // Fetch if not already fetched in this component instance
    // The dropdownsLoaded flag prevents re-fetching across remounts if data exists
    if (!hasFetched.current) {
      console.log('[AuthorityDashboard] Dispatching fetchAuthorityDropdowns...');
      hasFetched.current = true;
      dispatch(fetchAuthorityDropdowns());
    } else {
      console.log('[AuthorityDashboard] Already fetched in this mount, skipping');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - only run on mount

  return (
    <DashboardLayout
      roleTitle="Authority Portal"
      roleSubtitle="SJVN Limited"
      useDynamicMenuItems={true}
      sidebarOpen={sidebarOpen}
      onSidebarToggle={handleSidebarToggle}
    >
      <Outlet />
    </DashboardLayout>
  );
};

export default AuthorityDashboard;